import React, { useContext } from 'react'
import { Badge } from '@shared/components/badge'
import cx from 'classnames'

import { ApplicationFormContext } from '../../Application'

import styles from './style.module.scss'

interface Props {
	maxStepProgress: number
	percent: number
	text?: string
	disclaimerText?: string
	orderFromProps?: number
}
export const disclaimerText = (percent: number, text?: string) =>
	`+${percent}% ${text || 'за заполнение информации о себе'}`

export const ProgressBarNew = ({
	maxStepProgress,
	percent,
	text,
	disclaimerText,
	orderFromProps,
}: Props) => {
	const context = useContext(ApplicationFormContext)
	const order = context.currentStepNumber
	const total = 4

	return (
		<div className={styles.bar}>
			<div className={styles.step}>
				Шаг {orderFromProps || order} из {total}
			</div>
			<div className={styles.content}>
				<Badge theme='main' use='small'>
					{percent}%
				</Badge>
				<span className={styles.text}>{text || 'Вероятность одобрения кредита'}</span>
			</div>
			<div className={styles.trackWrap}>
				<div className={cx(styles.track, styles.trackCurrent)} style={{ width: `${percent}%` }} />
				<div
					className={cx(styles.track, styles.trackMax)}
					style={{ width: `${maxStepProgress}%` }}
				/>
			</div>
			<div className={styles.disclaimer}>{disclaimerText || 'Прогресс'}</div>
		</div>
	)
}
